import moment from 'moment';
import 'moment-timezone';

const momentCustom = (date) =>  moment(date).tz("America/Bogota"); // Configura la zona horaria predeterminada a UTC
export default momentCustom;